export const fmtPrice = (price, currency = "AED", t) => {
  if (!price || price <= 0) return t ? t("price_tba") : "—";
  const n = Number(price).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  return currency === "USD" ? `$${n}` : `${currency} ${n}`;
};

export const statusKey = {
  available: "available",
  sold_out: "sold_out",
  coming_soon: "coming_soon",
  limited_release: "limited_release",
};
